import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

// schema로부터 type을 자동으로 추출할 수 있도록 관리될 수 있는 지 확인
export interface ShareProperties {
  method: "iframe" | "embed";
  hidePlayerController: boolean;
  fill: boolean;
  showPostingTitle: boolean;
  showLike: boolean;
  useSharedLink: boolean;
  hideProductTag: boolean;
  rounded: boolean;
  device: "all" | "pc" | "mobile";
}

export const SharePostingSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.Select,
    id: "method",
    label: "퍼가기 방식",
    defaultValue: "iframe",
    options: [
      {
        label: "아이프레임",
        value: "iframe",
      },
      {
        label: "임베드",
        value: "embed",
      },
    ],
  },
  {
    type: FormFieldType.Switch,
    id: "hidePlayerController",
    label: "플레이어 컨트롤러",
  },
  {
    type: FormFieldType.Switch,
    id: "fill",
    label: "동영상 채우기",
  },
  {
    type: FormFieldType.Switch,
    id: "showPostingTitle",
    label: "포스팅 제목",
  },
  {
    type: FormFieldType.Switch,
    id: "showLike",
    label: "좋아요 버튼",
  },
  {
    type: FormFieldType.Switch,
    id: "useSharedLink",
    label: "공유하기 버튼",
  },
  {
    type: FormFieldType.Switch,
    id: "hideProductTag",
    label: "상품 태그",
  },
  {
    type: FormFieldType.Switch,
    id: "rounded",
    label: "부드러운 모서리",
  },
  {
    type: FormFieldType.Select,
    id: "device",
    label: "디바이스",
    defaultValue: "all",
    options: [
      {
        label: "전체",
        value: "all",
      },
      {
        label: "pc",
        value: "PC",
      },
      {
        label: "mobile",
        value: "모바일",
      },
    ],
  },
];
